(() => {
  angular.module('app').controller('tenant.views.irbmMyInvois.index', IRBMMyInvoisController);

  IRBMMyInvoisController.$inject = ['$scope', 'abp.services.app.commonLookup', 'appSession'];

  function IRBMMyInvoisController($scope, commonLookupSvc, appSession) {
    const vm = this;
    vm.tenancyName = appSession.tenant.tenancyName;
    vm.loading = 0;
    vm.saving = 0;
    vm.isClinic = App.isClinic();
    vm.countryCode = null;
    vm.editIrbmMyInvoisSettingsWidget = null;

    vm.save = save;

    $scope.$on('$viewContentLoaded', () => {
      App.initAjax();
    });

    function init() {
      getTenantCountryCode();
    }

    function save() {
      if (vm.editIrbmMyInvoisSettingsWidget && vm.editIrbmMyInvoisSettingsWidget.validateForm) {
        vm.editIrbmMyInvoisSettingsWidget.validateForm();
      }
    }

    function getTenantCountryCode() {
      vm.loading += 1;
      commonLookupSvc
        .getTenantCountryCode()
        .success((countryCode) => {
          vm.countryCode = countryCode;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    init();
  }
})();
